import * as React from 'react';
import { dateFormat, extractTextFromJson, isDateWithinOneWeek } from '../utils';

// component
import TopicCardCommntCount from './TopicCardCommentCount';

// mui
import Avatar from '@mui/material/Avatar';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// icons
import FaceIcon from '@mui/icons-material/Face';

// types
type TopicCardProps = {
    body: string,
    commentCount: number,
    postTime: string,
    title: string,
    topicMembers: null | { // openRangeが1（公開）の場合はnull
        email: string,
        userId: number,
        userName: string,
    }[],
    updatedTime: string,
    userName: string,
}

export default function TopicCardContent(props: TopicCardProps) {
    const {
        body,
        commentCount,
        title,
        topicMembers,
        updatedTime,
        userName,
    } = props;

    return (
        <>
            <Stack
                alignItems="center"
                direction="row"
                spacing={1}
                sx={{
                    ml: "auto",
                    mb: 2,
                }}
            >
                <Chip
                    label={topicMembers ? "限定トピック" : "公開トピック"}
                    color={topicMembers ? "primary" : "default"}
                    sx={{mr: "auto", fontSize: 12}}
                />

                {/* 下書き／非公開のチップを作成 */}
            </Stack>

            <Typography variant="h1" sx={{
                display: "flex",
                alignItems: "center",
                mb: 2,
                fontSize: 24,
                fontWeight: "bold",
                [`&>a`]: {
                    textDecoration: "none",
                    color: (theme) => theme.palette.grey[900],
                }
            }}>
                {isDateWithinOneWeek(updatedTime) &&
                    <Chip color="secondary" label="New" sx={{ mr: 1 }} />
                }
                {title}
            </Typography>

            <CardHeader
                avatar={
                    <Avatar variant="rounded" aria-label="author">
                        <FaceIcon sx={{ color: (theme) => theme.palette.grey[600], fontSize: 40 }} />
                    </Avatar>
                }
                title={userName}
                subheader={dateFormat(updatedTime)}
                sx={{
                    mb: 2,
                    p: 0,
                    '& .MuiCardHeader-avatar': {
                        mr: 1,
                        '& .MuiAvatar-root': {
                            backgroundColor: "transparent",
                        }
                    },
                }}
            />

            <CardContent
                sx={{
                    p: 0,
                    mb: 2,
                }}
            >
                <Typography sx={{mb: 2}}>
                    {extractTextFromJson(body, 140)}
                </Typography>
                <Stack direction="row">
                    <TopicCardCommntCount count={commentCount} />
                </Stack>
            </CardContent>
        </>
    );
}